import { ENV } from '../../config/env';

/**
 * Default Google Drive connection-card copy (data access / trust). Keep in sync with product & legal;
 * for urgent wording changes without a frontend release, set `VITE_GOOGLE_DRIVE_DATA_ACCESS_SUMMARY`
 * in the deploy environment. A future CMS/backend source can replace this module’s resolution.
 */
const DEFAULT_GOOGLE_DRIVE_DATA_ACCESS_SUMMARY =
  'Access is limited to what you authorize in Google: we use it to list folders you browse and upload files you start from Docufy. We do not sell your data, use it to train public models, or scan Drive in the background. Disconnect anytime here. Exact OAuth scopes appear under Permissions below when connected.';

export function getGoogleDriveDataAccessSummary(): string {
  const override = ENV.VITE_GOOGLE_DRIVE_DATA_ACCESS_SUMMARY;
  return override || DEFAULT_GOOGLE_DRIVE_DATA_ACCESS_SUMMARY;
}
